import React from 'react';
import {
    getChannelDeliveryPlatforms
} from 'helpers/channels';
import { Field } from 'redux-form';
import DropdownSelect from 'components/atoms/inputs/DropdownSelect';
import { DELIVERY_PLATFORM_MAP } from 'constants/platforms';
import styled from 'styled-components';
import { connect } from 'react-redux';

const NOT_CONFIGURABLE = 'Not Configurable';

const PlatformLogo = styled.img`
    width: 25px;
    height: 25px;
    margin-right: 5px;
    border: none;
`;

const DeliveryPlatformConfig = ({ channel, deliveryPlatform, readOnly = true, currentUser }) => {
    let platformConfig = NOT_CONFIGURABLE;

    if (readOnly) {
        const deliveryPlatformData = DELIVERY_PLATFORM_MAP[deliveryPlatform];

        if (deliveryPlatformData) {
            platformConfig = (
                <React.Fragment>
                    <PlatformLogo src={deliveryPlatformData.image.src}/>
                    <span>{deliveryPlatformData.text}</span>
                </React.Fragment>
            );
        }
    } else {
        const platformOptions = getChannelDeliveryPlatforms(channel, currentUser.scope);

        if (platformOptions) {
            platformConfig = (
                <Field
                    name={deliveryPlatform}
                    component={DropdownSelect}
                    list={platformOptions}
                />
            );
        }
    }
    return platformConfig;
};

const mapStateToProps = state => ({
    currentUser: state.users.currentUser
});

export default connect(mapStateToProps)(DeliveryPlatformConfig);




// WEBPACK FOOTER //
// ./src/components/organisms/entity/edit/DeliveryPlatformConfig.js